import {on} from 'delegated-events'

on('click', '#load-readme', function (event) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const editor = document.querySelector<HTMLTextAreaElement>('#gollum-editor-body')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const buffer = document.querySelector<HTMLElement>('#editor-body-buffer')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const undoLink = document.querySelector<HTMLElement>('#undo-load-readme')!

  const readmeText = buffer.textContent
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const readmeName = event.currentTarget.getAttribute('data-readme-name')!
  swapEditorAndBufferValues(editor, buffer)

  if (!(event.currentTarget instanceof HTMLButtonElement)) return
  event.currentTarget.disabled = true
  event.currentTarget.textContent = `${readmeName} loaded`
  /* eslint-disable-next-line github/no-d-none */
  undoLink.classList.remove('d-none')

  function hideUndoLinkIfChanged() {
    if (editor.value !== readmeText) {
      /* eslint-disable-next-line github/no-d-none */
      undoLink.classList.add('d-none')
      editor.removeEventListener('input', hideUndoLinkIfChanged)
    }
  }

  editor.addEventListener('input', hideUndoLinkIfChanged)
})

on('click', '#undo-load-readme', function (event) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const editor = document.querySelector<HTMLTextAreaElement>('#gollum-editor-body')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const buffer = document.querySelector<HTMLElement>('#editor-body-buffer')!

  swapEditorAndBufferValues(editor, buffer)
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const loadReadmeButton = document.querySelector<HTMLButtonElement>('#load-readme')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const readmeName = loadReadmeButton.getAttribute('data-readme-name')!

  loadReadmeButton.disabled = false
  // eslint-disable-next-line i18n-text/no-en
  loadReadmeButton.textContent = `Load ${readmeName}`
  /* eslint-disable-next-line github/no-d-none */
  event.currentTarget.classList.add('d-none')
})

function swapEditorAndBufferValues(editor: HTMLTextAreaElement, editorBodyBuffer: HTMLElement) {
  const oldEditorVal = editor.value
  editor.value = editorBodyBuffer.textContent || ''
  editorBodyBuffer.textContent = oldEditorVal
}
